import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import config from "../../config.js";

function GoogleLoginButton({ onCredential, onError }) {
  if (!config.GOOGLE_CLIENT_ID) return null;

  return (
    <GoogleOAuthProvider clientId={config.GOOGLE_CLIENT_ID}>
      <div className="google-login-wrapper">
        <GoogleLogin
          onSuccess={(credentialResponse) =>
            onCredential(credentialResponse.credential)
          }
          onError={onError}
          text="signin_with"
          width="100%"
          useOneTap={false}
        />
      </div>
    </GoogleOAuthProvider>
  );
}

export default GoogleLoginButton;
